import { gemKeyOf } from '../gemRows.js';
import { type ParsedResult, parseResult } from '../parsedResult.js';
import { asRecord } from '../resultValues.js';
import { risingKeyOf } from '../risingRows.js';
import { provenElementKeyOf } from './elementPool.js';

// Keep the original rows: Actions matches selections against its stored output.
export function chainRowsOf(
  result: unknown,
  kind: string | null,
  resultData: ParsedResult = parseResult(result, kind),
): { id: string; values: Record<string, unknown> }[] {
  if (resultData.kind === 'other') return resultData.rows;
  if (resultData.kind === 'element_pool')
    return resultData.parsed.success
      ? resultData.parsed.data.elements.map((values) => ({
          id: provenElementKeyOf(values),
          values,
        }))
      : [];
  if (resultData.kind === 'element_list')
    return resultData.parsed.success
      ? resultData.parsed.data.gems.map((values) => ({ id: gemKeyOf(values), values }))
      : [];
  if (resultData.kind === 'rising_elements')
    return resultData.parsed.success
      ? resultData.parsed.data.elements.map((values) => ({ id: risingKeyOf(values), values }))
      : [];
  if (resultData.kind === 'combination_list')
    return resultData.parsed.success
      ? resultData.parsed.data.combinations.map((values) => ({ id: values.combo_id, values }))
      : [];
  const field =
    resultData.kind === 'ideation_brief'
      ? 'briefs'
      : kind === 'storyboard' || kind === 'banner_storyboard'
        ? 'versions'
        : null;
  if (field === null) return [];
  const rows = asRecord(result)?.[field];
  if (!Array.isArray(rows)) return [];
  return rows.flatMap((entry) => {
    const values = asRecord(entry);
    if (values === null) return [];
    const id = values['name'];
    return typeof id === 'string' ? [{ id, values }] : [];
  });
}
